module.exports = __webpack_public_path__ + "img/minp2.dbd37c09.jpg";